import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const FirstNameEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const name = useAppSelector(state => state.registration.currentRegistration?.name) || {};
  const value = name.first || '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      name: {
        ...name,
        first: e.target.value,
      },
    }));
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      size="small"
      label="First Name"
      required
    />
  );
};

export default FirstNameEdit;
